export const runtime = {
    Metadata: [
        {
            methods: {
                metadata: {
                    description: 'Returns the metadata of a runtime',
                    params: [],
                    type: 'OpaqueMetadata'
                }
            },
            version: 1
        }
    ]
};